import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

/** LatAm local-account helpers (banks, provinces, bank accounts, provision). */
@Injectable({ providedIn: 'root' })
export class NotbankService {
  constructor(private http: HttpService) {}

  getBanks(opts: { currency?: string; country?: string }): Observable<any> {
    let params = new HttpParams();
    if (opts.currency) params = params.set('currency', opts.currency);
    if (opts.country) params = params.set('country', opts.country);
    return this.http.get('local-account/banks', params);
  }

  getProvinces(opts: { currency?: string; country?: string }): Observable<any> {
    let params = new HttpParams();
    if (opts.currency) params = params.set('currency', opts.currency);
    if (opts.country) params = params.set('country', opts.country);
    return this.http.get('local-account/provinces', params);
  }

  listBankAccounts(opts: {
    client_id?: number | string;
    currency?: string;
  }): Observable<any> {
    let params = new HttpParams();
    if (opts.client_id != null) params = params.set('client_id', String(opts.client_id));
    if (opts.currency) params = params.set('currency', opts.currency);
    return this.http.get('local-account/bank-accounts', params);
  }

  addBankAccount(body: Record<string, unknown>): Observable<any> {
    return this.http.post('local-account/bank-accounts', body);
  }

  provision(body: Record<string, unknown>): Observable<any> {
    return this.http.post('local-account/provision', body);
  }

  getAccount(clientId?: number | string): Observable<any> {
    let params = new HttpParams();
    if (clientId != null) params = params.set('client_id', String(clientId));
    return this.http.get('local-account/account', params);
  }
}
